<template  lang="pug">
  .submit-to-it
    .submit-to-procurement__content
      el-row(:gutter="20")
        el-col(:span="4").text-right {{ $t('IT账号') }}
        el-col(:span="10")
          el-select(
            :value="selectedId"
            @change="onChange"
            :placeholder="$t('请选择账号')",
            style="width: 200px"
            @input="v => $emit('input', v)"
          )
            el-option(
              v-for="o in ITOptions"
              :key="o.user_id"
              :value="o.user_id"
              :label="o.mail"
            )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import axios from 'axios'
import { pickBy } from 'lodash'

const fetchUserByDept = (code, vendorID, campaignId) => {
  let params = {
    struct_group_code: code,
    vendor_id: vendorID,
    campaign_id: campaignId
  }

  return axios.get('/admin/user/getUserByDept', {
    params: pickBy(params, v => { return v != null })
  })
}

export default {
  model: {
    prop: 'selectedId'
  },
  props: {
    selectedId: {
      type: Number,
      default () {
        return null
      }
    }
  },
  components: {
    TitleBar
  },
  data () {
    return {
      ITOptions: []
    }
  },
  mounted () {
    this.fetchUserByDept()
  },
  methods: {
    async fetchUserByDept () {
      const res = await fetchUserByDept('it')
      this.ITOptions = res
    },
    onChange (val) {
      this.$emit('input', val)
      this.$emit('email-change', this.ITOptions.find(i => i.user_id === val).mail)
    }
  }
}
</script>

<style lang="stylus">
.submit-to-procurement
  > span
    margin-right 10px

.submit-to-procurement__content
  padding 20px
  > span
    margin-right 10px
</style>
